import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';

const useStyles = theme => ({
  formControl: {
    marginBottom: theme.spacing(5),
    marginLeft: theme.spacing(2),
    minWidth: 120
  }
});

class SelectBox extends React.Component{

  constructor(props) {
    super(props);

    this.state = {
      value: '',
      open: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
  }

  updateSelectedItem(id){
    this.setState({
      value: id
    });
  }

  handleChange(event){
    this.setState({
      value: event.target.value
    });
    this.props.handler(event.target.value);
  };

  handleClose(){
    this.setState({
      open: false
    });
  };

  handleOpen(){
    this.setState({
      open: true
    });
  };

  render(){

    const { classes } = this.props;
    const error = this.state.value === '';
    return (
      <div>
        <FormControl className={classes.formControl} error={error}>
          <InputLabel id="controlled-open-select-label">{this.props.inputName}</InputLabel>
          <Select
            labelId="controlled-open-select-label"
            id="controlled-open-select"
            open={this.state.open}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            value={this.state.value}
            onChange={this.handleChange} >
            <MenuItem value=""><em>None</em></MenuItem>
            {
              this.props.list.map((option, index) => <MenuItem key={index} value={option.id}>{option.name}</MenuItem>
            )}
          </Select>
          <FormHelperText>Required</FormHelperText>
        </FormControl>
      </div>
    );
  }

}

export default withStyles(useStyles)(SelectBox);
